var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.753 18.8404L0.818115 22.9528L5.753 27.0652",
    stroke: "#3D96C2",
    strokeWidth: 1.48213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9126 18.8404L23.8475 22.9528L18.9126 27.0652",
    stroke: "#3D96C2",
    strokeWidth: 1.48213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6231 13.9054L9.04321 32",
    stroke: "#3D96C2",
    strokeWidth: 1.48213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4862 3.13363C21.5667 2.91597 21.8746 2.91597 21.9551 3.13363L23.2999 6.76786C23.3252 6.83629 23.3792 6.89024 23.4476 6.91556L27.0818 8.26035C27.2995 8.34089 27.2995 8.64874 27.0818 8.72927L23.4476 10.0741C23.3792 10.0994 23.3252 10.1533 23.2999 10.2218L21.9551 13.856C21.8746 14.0737 21.5667 14.0737 21.4862 13.856L20.1414 10.2218C20.1161 10.1533 20.0621 10.0994 19.9937 10.0741L16.3595 8.72927C16.1418 8.64874 16.1418 8.34089 16.3595 8.26035L19.9937 6.91556C20.0621 6.89024 20.1161 6.83629 20.1414 6.76786L21.4862 3.13363Z",
    fill: "#3D96C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2561 12.9788C27.3038 12.85 27.4859 12.85 27.5336 12.9788L28.3293 15.1292C28.3443 15.1697 28.3762 15.2016 28.4167 15.2166L30.5671 16.0123C30.6959 16.06 30.6959 16.2422 30.5671 16.2898L28.4167 17.0855C28.3762 17.1005 28.3443 17.1325 28.3293 17.1729L27.5336 19.3234C27.4859 19.4521 27.3038 19.4521 27.2561 19.3234L26.4604 17.1729C26.4454 17.1325 26.4135 17.1005 26.373 17.0855L24.2226 16.2898C24.0938 16.2422 24.0938 16.06 24.2226 16.0123L26.373 15.2166C26.4135 15.2016 26.4454 15.1697 26.4604 15.1292L27.2561 12.9788Z",
    fill: "#3D96C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6986 2.72822C28.7276 2.64983 28.8384 2.64983 28.8674 2.72822L29.3518 4.0372C29.3609 4.06185 29.3804 4.08128 29.405 4.0904L30.714 4.57477C30.7924 4.60378 30.7924 4.71466 30.714 4.74367L29.405 5.22804C29.3804 5.23716 29.3609 5.25659 29.3518 5.28124L28.8674 6.59022C28.8384 6.66862 28.7276 6.66862 28.6986 6.59022L28.2142 5.28124C28.2051 5.25659 28.1856 5.23716 28.161 5.22804L26.852 4.74367C26.7736 4.71466 26.7736 4.60378 26.852 4.57477L28.161 4.0904C28.1856 4.08128 28.2051 4.06185 28.2142 4.0372L28.6986 2.72822Z",
    fill: "#3D96C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMod);
export default __webpack_public_path__ + "static/media/mod.eac2275f7aef6520c0b8e212b1cc2598.svg";
export { ForwardRef as ReactComponent };